import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/operated/hotword',
  owner: '/home',
  authority: 'hotWord',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};